var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 11,
    viewBox: "0 0 34 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8673 10.4609H12.2605L13.8855 0.372375H16.4923L14.8673 10.4609Z",
    fill: "#0A67B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.026 0.372416L7.52083 7.27867L7.21615 5.78908L6.33594 1.25262C6.33594 1.25262 6.23438 0.338562 5.08333 0.338562H0.986979L0.953125 0.507833C0.953125 0.507833 2.20573 0.778666 3.69531 1.65887L5.96354 10.3933H8.70573L12.8698 0.338562H10.026V0.372416Z",
    fill: "#0A67B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6433 10.4609H33.047L30.948 0.40625H28.849C27.8673 0.40625 27.6303 1.15104 27.6303 1.15104L23.7371 10.4609H26.4792L27.0209 8.97135H30.3386L30.6433 10.4609ZM27.7657 6.90625L29.1537 3.14844L29.9324 6.90625H27.7657Z",
    fill: "#0A67B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.94 2.8099L24.3124 0.643229C24.3124 0.643229 23.1614 0.203125 21.9426 0.203125C20.6562 0.203125 17.5416 0.778646 17.5416 3.52083C17.5416 6.1276 21.164 6.16146 21.164 7.51562C21.164 8.86979 17.914 8.63281 16.8306 7.78646L16.4583 10.0547C16.4583 10.0547 17.6431 10.6302 19.4036 10.6302C21.1978 10.6302 23.8723 9.71615 23.8723 7.17708C23.8723 4.57031 20.2161 4.33333 20.2161 3.18229C20.2499 2.03125 22.8228 2.20052 23.94 2.8099Z",
    fill: "#0A67B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 5.8229L6.36979 1.28644C6.36979 1.28644 6.26823 0.372375 5.11719 0.372375H0.986979L0.953125 0.541646C0.953125 0.541646 2.95052 0.947896 4.84635 2.50519C6.64062 3.99477 7.25 5.8229 7.25 5.8229Z",
    fill: "#FAA634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.b3e8f56e8caa0768cf844cd80cf78bd4.svg";
export { ForwardRef as ReactComponent };